import { useEffect } from "react";

const saveUTMParams = () => {
  const utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];

  // Correcting the URL: Replace the 2nd '?' with '&' if it is there
  let search = window.location.search.replace(/\?(?=.*\?)/g, "&");
  const params = new URLSearchParams(search);

  let hasUTMParams = false;

  utmKeys.forEach((key) => {
    const newValue = params.get(key);
    const storedValue = localStorage.getItem(key);

    // If there is a UTM param and it is na new value, update it
    if (newValue && newValue !== storedValue) {
      localStorage.setItem(key, newValue);
      hasUTMParams = true;
    }
  });

  // If ttehe are no new UTM tags in te URL, try to get them from referer header
  if (!hasUTMParams && document.referrer) {
    try {
      const refererUrl = new URL(document.referrer);
      const refererParams = new URLSearchParams(refererUrl.search);

      utmKeys.forEach((key) => {
        const refValue = refererParams.get(key);
        const storedValue = localStorage.getItem(key);

        if (refValue && refValue !== storedValue) {
          localStorage.setItem(key, refValue);
        }
      });
    } catch (error) {
      console.error("Error parsing referer URL:", error);
    }
  }
};

const useUTMTracker = () => {
  useEffect(() => {
    saveUTMParams();
  }, []);
};

export default useUTMTracker;
